export const types = {
  INIT: 'opDefs/listPage/init',
  NEW_OP_DEF_MODAL_OPEN: 'opDefs/listPage/NEW_OP_DEF_MODAL_OPEN',
  NEW_OP_DEF_MODAL_CLOSE: 'opDefs/listPage/NEW_OP_DEF_MODAL_CLOSE',
  CREATE_REQUEST: 'opDefs/listPage/CREATE_REQUEST',
  CREATE_SUCCESS: 'opDefs/listPage/CREATE_SUCCESS',
  CREATE_ERROR: 'opDefs/listPage/CREATE_ERROR',
};

export const init = ({ opDefs }) => ({
  type: types.INIT,
  payload: { opDefs },
});

export const createOpDef = {
  request: (payload) => ({
    type: types.CREATE_REQUEST,
    payload,
  }),
  success: (payload) => ({
    type: types.CREATE_SUCCESS,
    payload,
  }),
  error: (payload) => ({
    type: types.CREATE_ERROR,
    payload,
  }),
};

export const newOpDefModal = {
  close: () => ({
    type: types.NEW_OP_DEF_MODAL_CLOSE,
  }),
  open: () => ({
    type: types.NEW_OP_DEF_MODAL_OPEN,
  }),
};
